import type { ElementRef, SVGProps } from 'react';
import { forwardRef } from 'react';

export const FullModalAsideTopOval = forwardRef<ElementRef<'svg'>, SVGProps<SVGSVGElement>>(
  (props: SVGProps<SVGSVGElement>, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="176"
        viewBox="0 0 216 176"
        width="216"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          clipRule="evenodd"
          d="M216 -35C216 81.5321 121.532 176 4.99999 176C-25.241 176 -53.9961 169.638 -80 158.18V-83H210.516C214.103 -67.5803 216 -51.5116 216 -35Z"
          fill="white"
          fillRule="evenodd"
          opacity="0.1"
        />
      </svg>
    );
  }
);

FullModalAsideTopOval.displayName = 'FullModalAsideTopOval';
